import React, { useState } from 'react';
import { AsyncTypeahead } from 'react-bootstrap-typeahead';

const SponsorSearch = ({ onSponsorSelect }) => {
  const [selectedOption, setSelectedOption] = useState(null);
  const [searchResults, setSearchResults] = useState([]);

  const handleSearch = async (query) => {
    const response = await fetch(`/admin/companies/sponsor_search?q=${query}`);
    const data = await response.json();
    setSearchResults(data.data);
  };

  const handleSponsorSelect = (selected) => {
    if (selected.length > 0) {
      onSponsorSelect(selected[0]);
    }
  };

  const renderMenuItemChildren = (option, props) => (
    <div key={option.id}>
      <span>{option.name}</span>
    </div>
  );

  return (
    <>
      <div>
        <AsyncTypeahead
          id="sponsor-search"
          labelKey="name"
          isLoading={!searchResults}
          options={searchResults}
          minLength={3}
          onSearch={handleSearch}
          onChange={handleSponsorSelect}
          placeholder="Search for a Company"
          selected={selectedOption ? [selectedOption] : []}
          renderMenuItemChildren={renderMenuItemChildren}
        />
      </div>
    </>
  );
};

export default SponsorSearch;
